<template>
    <div
        class="base-notification-card"
        role="button"
        tabindex="0"
        @click="$emit('cardClicked', id)"
        @keydown.space.prevent="$emit('cardClicked', id)"
        @keydown.enter.prevent="$emit('cardClicked', id)">
        <div class="avatar-container">
            <user-icon :user="user" />
        </div>
        <div class="header-container">
            <!-- eslint-disable vue/no-v-html -->
            <div
                class="header"
                v-html="sanitizedHeader" />
            <!-- eslint-enable vue/no-v-html -->
        </div>
        <div class="dot-container">
            <div
                v-if="unread"
                class="dot" />
        </div>

        <div class="content-container">
            <slot name="content" />
        </div>

        <div class="actions-container">
            <slot name="actions" />
        </div>

        <div class="timestamp">
            {{ timeStamp }}
        </div>
    </div>
</template>

<script>
import UserIcon from '@/common/user/user-icon/user-icon.vue';

export default {
    name: 'BaseNotificationCard',
    components: {
        UserIcon,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
        user: {
            type: Object,
            default: () => ({}),
        },
        header: {
            type: String,
            default: '',
        },
        timeStamp: {
            type: String,
            default: '',
        },
        unread: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cardClicked'],
    computed: {
        sanitizedHeader () {
            return this.$sanitize(this.header);
        },
    },
};
</script>

<style scoped lang="less">
.base-notification-card {
    display: grid;
    grid-template-areas:
        'avatar header dot'
        'avatar content content'
        'avatar actions actions'
        'avatar timestamp timestamp';
    grid-template-columns: min-content 1fr min-content;
    column-gap: 12px;
    row-gap: 4px;
    padding: 10px 12px;
    border-radius: 5px;

    .avatar-container {
        grid-area: avatar;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding-top: 4px;
    }

    .header-container {
        grid-area: header;
        display: flex;
        align-items: center;
    }

    .dot-container {
        grid-area: dot;
        display: flex;
        justify-content: center;
        align-items: center;

        .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: var(--static-palette-pink-120);
        }
    }

    .content-container {
        grid-area: content;
        color: var(--palette-gray-70);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }

    .actions-container {
        grid-area: actions;
        padding-top: 8px;
    }

    .timestamp {
        grid-area: timestamp;
        color: var(--palette-gray-70);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
    }

    &:hover {
        background-color: var(--palette-gray-10);
        cursor: pointer;
    }

    &:focus-visible {
        outline: 2px solid var(--palette-gray-90);
        outline-offset: -1px;
    }
}
</style>
